

 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

  

 

const PostCargoTransferData = (data: any): Promise<any>  =>
request({
  url: ApiURL.Command.PostCargoTransferData,
  method: RequestType.POST,
  data,
}); 

const AddShippingFeeManagement=(data:any):Promise<any>=>request({
  url:ApiURL.Command.AddShippingFeeManagement,
  method: RequestType.POST,
  data
 }); 

 const UpdateShippingFeeManagement=(data:any):Promise<any>=>request({
  url:ApiURL.Command.UpdateShippingFeeManagement,
  method: RequestType.POST,
  data,
  headers:{
    'effecteditem': data.id
  }
 });

 const GetShippingFeeManagementListByFilter=(data:any):Promise<any>=>request({
  url:ApiURL.Command.GetShippingFeeManagementListByFilter,
  method: RequestType.POST,
  data
 }); 

 const DeleteShippingFeeManagement=(id:string):Promise<any>=>request({
  url:ApiURL.Command.DeleteShippingFeeManagement.concat("/").concat(id),
  method: RequestType.DELETE,
  headers:{
    'effecteditem': id
  }
 }); 

const CargoCommand = {
  PostCargoTransferData,
  AddShippingFeeManagement,
  UpdateShippingFeeManagement, 
  GetShippingFeeManagementListByFilter,
  DeleteShippingFeeManagement
};

export default CargoCommand;
